var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-page config-page-app"},[_c('v-row',[_c('v-col',{staticClass:"info-col",attrs:{"cols":"12","lg":"3","md":"3","sm":"12","xs":"12"}},[_c('v-row',{staticClass:"px-0"},[_c('InfoCard')],1)],1),_c('v-col',{staticClass:"content-col",attrs:{"cols":"12","lg":"9","md":"9","sm":"12","xs":"12"}},[_c('Form')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }